(() => {
  'use strict';

  const EXCLUSIVE_PROPERTY = '_adventskalender_exklusiv';
  const TOAST_ID = 'adventskalender-cart-guard-toast';

  const messages = {
    calendarBlocked:
      'Der Adventskalender muss separat bestellt werden. Bitte entfernen Sie zuerst alle anderen Produkte aus dem Warenkorb. Ihr bestehender Warenkorb wurde nicht verändert.',

    otherProductBlocked:
      'Dieses Produkt kann nicht zusammen mit dem Adventskalender bestellt werden. Bitte schliessen Sie zuerst Ihre Adventskalender-Bestellung ab oder entfernen Sie den Adventskalender aus dem Warenkorb.',

    cartCheckFailed:
      'Der Warenkorb konnte momentan nicht geprüft werden. Bitte versuchen Sie es erneut.',
  };

  window.AdventskalenderCartGuard = {
    loaded: true,
    version: '2.1',
  };

  console.info('[Adventskalender Cart Guard] geladen');

  function isExclusiveCartItem(item) {
    return (
      item.properties &&
      String(item.properties[EXCLUSIVE_PROPERTY]) === 'true'
    );
  }

  async function fetchCart() {
    const root = window.Shopify?.routes?.root || '/';

    const response = await fetch(`${root}cart.js`, {
      method: 'GET',
      credentials: 'same-origin',
      cache: 'no-store',
      headers: {
        Accept: 'application/json',
      },
    });

    if (!response.ok) {
      throw new Error(`Warenkorbabfrage fehlgeschlagen: ${response.status}`);
    }

    return response.json();
  }

  function removeToast() {
    document.getElementById(TOAST_ID)?.remove();
  }

  function clearProductError(productForm) {
    const wrapper = productForm.querySelector(
      '.product-form__error-message-wrapper'
    );

    const messageElement = wrapper?.querySelector(
      '.product-form__error-message'
    );

    if (wrapper && messageElement) {
      messageElement.textContent = '';
      wrapper.setAttribute('hidden', '');
    }

    removeToast();
  }

  function showToast(message) {
    removeToast();

    const toast = document.createElement('div');
    toast.id = TOAST_ID;
    toast.className = 'adventskalender-cart-guard-toast';
    toast.setAttribute('role', 'alert');
    toast.setAttribute('aria-live', 'assertive');

    const text = document.createElement('span');
    text.className = 'adventskalender-cart-guard-toast__text';
    text.textContent = message;

    const closeButton = document.createElement('button');
    closeButton.type = 'button';
    closeButton.className = 'adventskalender-cart-guard-toast__close';
    closeButton.setAttribute('aria-label', 'Meldung schliessen');
    closeButton.textContent = '×';
    closeButton.addEventListener('click', removeToast);

    toast.append(text, closeButton);
    document.body.appendChild(toast);

    requestAnimationFrame(() => {
      toast.classList.add('is-visible');
    });
  }

  function showProductError(productForm, message) {
    const wrapper = productForm.querySelector(
      '.product-form__error-message-wrapper'
    );

    const messageElement = wrapper?.querySelector(
      '.product-form__error-message'
    );

    /*
     * Normale Produktseite:
     * Dawn-Fehlerbereich beim Kaufbutton verwenden.
     */
    if (wrapper && messageElement) {
      messageElement.textContent = message;
      wrapper.removeAttribute('hidden');

      wrapper.scrollIntoView({
        behavior: 'smooth',
        block: 'nearest',
      });

      return;
    }

    /*
     * Quick Add:
     * Meldung als Toast anzeigen, ohne die Produktkarte umzubauen.
     */
    showToast(message);
  }

  function getGiftFields(form) {
  const elements = Array.from(form.elements);

  const giftCheckbox = elements.find(
    (element) =>
      element.name === 'properties[Als Geschenk mit Nachricht]'
  );

  const giftMessage = elements.find(
    (element) =>
      element.name === 'properties[Geschenknachricht]'
  );

  return {
    giftCheckbox,
    giftMessage,
  };
}

function syncGiftMessageRequirement(form) {
  const { giftCheckbox, giftMessage } = getGiftFields(form);

  if (!giftCheckbox || !giftMessage) {
    return;
  }

  giftMessage.required = giftCheckbox.checked;

  if (!giftCheckbox.checked) {
    giftMessage.setCustomValidity('');
  }
}

function validateGiftMessage(form) {
  const { giftCheckbox, giftMessage } = getGiftFields(form);

  /*
   * Produkt hat keine Geschenkoption:
   * Keine weitere Prüfung nötig.
   */
  if (!giftCheckbox || !giftMessage) {
    return true;
  }

  giftMessage.required = giftCheckbox.checked;
  giftMessage.setCustomValidity('');

  /*
   * Geschenk aktiviert, aber keine Nachricht eingegeben.
   */
  if (giftCheckbox.checked && !giftMessage.value.trim()) {
    giftMessage.setCustomValidity(
      'Bitte gib eine Geschenknachricht ein.'
    );

    giftMessage.reportValidity();
    giftMessage.focus();

    return false;
  }

  return true;
}

  async function validateProductForm(productForm) {
    clearProductError(productForm);

    const cart = await fetchCart();

    const addingCalendar =
      productForm.dataset.adventskalenderExclusive === 'true';

    const cartHasCalendar = cart.items.some(isExclusiveCartItem);

    const cartHasOtherProducts = cart.items.some(
      (item) => !isExclusiveCartItem(item)
    );

    console.info('[Adventskalender Cart Guard] Prüfung', {
      addingCalendar,
      cartHasCalendar,
      cartHasOtherProducts,
    });

    if (addingCalendar && cartHasOtherProducts) {
      showProductError(productForm, messages.calendarBlocked);
      return false;
    }

    if (!addingCalendar && cartHasCalendar) {
      showProductError(productForm, messages.otherProductBlocked);
      return false;
    }

    clearProductError(productForm);

    return true;
  }

  function continueSubmission(form, submitButton) {
    form.dataset.adventGuardApproved = 'true';

    if (
      typeof form.requestSubmit === 'function' &&
      submitButton instanceof HTMLElement
    ) {
      form.requestSubmit(submitButton);
      return;
    }

    if (typeof form.requestSubmit === 'function') {
      form.requestSubmit();
      return;
    }

    form.submit();
  }

  /*
 * Geschenknachricht wird Pflichtfeld,
 * sobald "Als Geschenk mit Nachricht" aktiviert ist.
 */
document.addEventListener('change', (event) => {
  const element = event.target;

  if (!(element instanceof HTMLInputElement)) {
    return;
  }

  if (
    element.name !== 'properties[Als Geschenk mit Nachricht]'
  ) {
    return;
  }

  if (!element.form) {
    return;
  }

  syncGiftMessageRequirement(element.form);
});

/*
 * Eigene Fehlermeldung wieder entfernen,
 * sobald der Kunde Text eingibt.
 */
document.addEventListener('input', (event) => {
  const element = event.target;

  if (!(element instanceof HTMLInputElement)) {
    return;
  }

  if (element.name !== 'properties[Geschenknachricht]') {
    return;
  }

  element.setCustomValidity('');
});

  /*
   * Reguläre Klicks auf Produktseiten und Quick Add abfangen.
   */
  document.addEventListener(
    'click',
    async (event) => {
      const clickedElement =
        event.target instanceof Element ? event.target : null;

      const submitButton = clickedElement?.closest(
        'product-form button[type="submit"][name="add"]'
      );

      if (!submitButton) {
        return;
      }

      const productForm = submitButton.closest('product-form');
      const form = submitButton.form || productForm?.querySelector('form');

      if (!productForm || !form) {
        return;
      }

      event.preventDefault();
      event.stopImmediatePropagation();

      /*
      * Geschenkoption prüfen, bevor der Warenkorb geprüft wird.
      */
      if (!validateGiftMessage(form)) {
        return;
      }

      if (form.dataset.adventGuardChecking === 'true') {
        return;
      }

      form.dataset.adventGuardChecking = 'true';
      submitButton.setAttribute('aria-disabled', 'true');

      try {
        const isValid = await validateProductForm(productForm);

        if (isValid) {
          submitButton.removeAttribute('aria-disabled');
          continueSubmission(form, submitButton);
        }
      } catch (error) {
        console.error('[Adventskalender Cart Guard]', error);
        showProductError(productForm, messages.cartCheckFailed);
      } finally {
        delete form.dataset.adventGuardChecking;
        submitButton.removeAttribute('aria-disabled');
      }
    },
    true
  );

  /*
   * Absenden per Tastatur oder durch andere Theme-Funktionen absichern.
   */
  document.addEventListener(
    'submit',
    async (event) => {
      const form = event.target;

      if (!(form instanceof HTMLFormElement)) {
        return;
      }

      const productForm = form.closest('product-form');

      if (!productForm) {
        return;
      }

      if (form.dataset.adventGuardApproved === 'true') {
        delete form.dataset.adventGuardApproved;
        return;
      }

      event.preventDefault();
      event.stopImmediatePropagation();

      if (form.dataset.adventGuardChecking === 'true') {
        return;
      }

      form.dataset.adventGuardChecking = 'true';

      try {
        const isValid = await validateProductForm(productForm);

        if (isValid) {
          continueSubmission(form, event.submitter);
        }
      } catch (error) {
        console.error('[Adventskalender Cart Guard]', error);
        showProductError(productForm, messages.cartCheckFailed);
      } finally {
        delete form.dataset.adventGuardChecking;
      }
    },
    true
  );
})();